"use client";

import { I18nUtil } from "@utils/i18n";
import { Icon } from "@ospweb/sdk-ui";
import NextImage from "@components/NextImage";
import React from "react";
import Translations from "@translate/components/Home/AppRating/AppRatingContentBody";

const I18n = I18nUtil.createScoped(Translations);

/** 评分态内容区：图标、标题、描述、5 颗星（静态） */
export const AppRatingContentBody: React.FC = () => (
  <div className="flex flex-col items-center gap-4">
    <div className="relative h-[28px] w-[56px] shrink-0">
      <NextImage
        src="/edgen_logo_full_v2.svg"
        alt=""
        width={56}
        height={28}
        className="h-full w-full object-contain object-center"
      />
    </div>
    <div className="flex w-full flex-col items-center gap-2 text-center">
      <h2
        aria-label="App Rating Content Body h2"
        data-openreplay-label="home_appratingcontentbody_h2"
        id="sem-app-rating-content-body-h2"
        className="headline_regular_s text-content_primary"
      >
        {I18n.t("Satisfied with Ed?")}
      </h2>
      <p className="body_m text-content_secondary">
        {I18n.t(
          "If Ed's helped you get a clearer handle on your money, a quick rating helps more people find us.",
        )}
      </p>
    </div>
    <div className="flex items-center justify-center gap-4">
      {[0, 1, 2, 3, 4].map((i) => (
        <Icon
          key={i}
          name="start-fill"
          size={32}
          className="shrink-0 text-content_brand_primary"
        />
      ))}
    </div>
  </div>
);
